import * as styles from "./DropdownSelect.module.less";
import { Icon, Icons } from "../Buttons";
import _ from "lodash";
import { Key, useCallback, useState } from "react";
import { ClickAwayListener } from "@mui/material";

export interface DropdownOption<T> {
    text: string;
    value: T;
}

export interface DropdownSelectProps<T> {
    className: string;
    selected: DropdownOption<T>;
    options: DropdownOption<T>[];
    scroll?: (step: number) => void;
    select: (value: T) => void;
}

export function DropdownSelect<T extends Key>(props: DropdownSelectProps<T>) {
    const [open, setOpen] = useState(false);
    
    // React registers its listener for the wheel event in passive mode
    // which means that it cannot be prevented from scrolling the page.
    // Manually add a wheel listener as a workaround.
    const refCallback = useCallback((node: HTMLDivElement|null) => {
        if (props.scroll) {
            const ac = new AbortController();
            if (node) {
                node.addEventListener('wheel', e => {
                    e.preventDefault();
                    if (e.deltaY > 0) {
                        props.scroll!(1);
                    } else if (e.deltaY < 0) {
                        props.scroll!(-1);
                    }
                }, { signal: ac.signal });
                return () => ac.abort();
            }
        }
    }, [props.scroll]);

    return (
        <div className={props.className} style={{position: 'relative'}}>
            <div className={open ? styles.dropdownTitleSelecting : styles.dropdownTitle} onClick={() => setOpen(true)}>{props.selected.text}</div>
            {
                open && (
                    <ClickAwayListener onClickAway={() => setOpen(false)}>
                        <div className={styles.dropdownList} ref={refCallback}>
                            {
                                props.scroll && (
                                    <div className={styles.option} onClick={() => props.scroll!(-1)}><Icon icon={Icons.ChevronUp}/></div>
                                )
                            }
                            {
                                props.options.map(x => {
                                    return (
                                        <div onClick={() => { setOpen(false); props.select(x.value); }} className={x.value === props.selected.value ? styles.selectedOption : styles.option} key={x.value}>{x.text}</div>
                                    )
                                })
                            }
                            {
                                props.scroll && (
                                    <div className={styles.option} onClick={() => props.scroll!(1)}><Icon icon={Icons.ChevronDown}/></div>
                                )
                            }
                        </div>
                    </ClickAwayListener>
                )
            }
        </div>
    );
};
